import React from 'react';
import { Box } from '@mui/material';
import {
  LocalFireDepartment as FireIcon,
  Apartment as BuildingIcon,
  Warning as WarningIcon,
  Thunderstorm as WeatherIcon,
  LocalHospital as MedicalIcon,
  Shield as SecurityIcon,
  Science as HazmatIcon,
} from '@mui/icons-material';
import { appColors } from '../../Config/Theme';
import { IncidentType } from '../../Types/enums';

interface IncidentIconProps {
  incidentType: string | number;
}

const iconMap: Record<string, { icon: React.ReactElement; bgcolor: string }> = {
  [IncidentType.Drill]: { icon: <BuildingIcon sx={{ color: appColors.primary.main, fontSize: 22 }} />, bgcolor: appColors.primary.light },
  [IncidentType.Fire]: { icon: <FireIcon sx={{ color: 'white', fontSize: 22 }} />, bgcolor: appColors.status.warning },
  [IncidentType.Weather]: { icon: <WeatherIcon sx={{ color: 'white', fontSize: 22 }} />, bgcolor: '#5C6BC0' },
  [IncidentType.Medical]: { icon: <MedicalIcon sx={{ color: 'white', fontSize: 22 }} />, bgcolor: appColors.status.error },
  [IncidentType.Security]: { icon: <SecurityIcon sx={{ color: 'white', fontSize: 22 }} />, bgcolor: appColors.status.errorDark },
  [IncidentType.Hazmat]: { icon: <HazmatIcon sx={{ color: 'white', fontSize: 22 }} />, bgcolor: '#7B1FA2' },
};

const defaultIcon = { icon: <WarningIcon sx={{ color: appColors.status.warning, fontSize: 22 }} />, bgcolor: appColors.status.warningBg };

const IncidentIcon: React.FC<IncidentIconProps> = ({ incidentType }) => {
  const key = String(incidentType).toLowerCase();
  const { icon, bgcolor } = iconMap[key] ?? defaultIcon;

  return (
    <Box
      sx={{
        width: 44,
        height: 44,
        borderRadius: '12px',
        bgcolor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {icon}
    </Box>
  );
};

export default IncidentIcon;
